import React from 'react';
import { Inbox } from 'lucide-react';

interface Props {
  title?: string;
  hint?: string;
  icon?: React.ReactNode;
}

/** Empty-state placeholder used by every list view in the admin console. */
export const EmptyState: React.FC<Props> = ({
  title = 'Geen gegevens',
  hint,
  icon = <Inbox className="w-6 h-6" />,
}) => (
  <div className="p-12 flex flex-col items-center justify-center text-center text-ink/45 dark:text-white/45">
    <div className="mb-3 text-ink/30 dark:text-white/30">{icon}</div>
    <p className="text-sm font-semibold text-ink/65 dark:text-white/65">{title}</p>
    {hint && <p className="text-xs text-ink/45 dark:text-white/45 mt-1 max-w-sm">{hint}</p>}
  </div>
);
